export enum StopTypes {
  UEBERGABE = "Übergabe",
  WECHSEL = "Wechsel",
  ABHOLUNG = "Abholung",
}

export function castStopTypeEnum(value: any): string {
  switch (value) {
    case StopTypes.UEBERGABE:
      return 'OPTIMIZATION_RUN_STOPS.STOP_TYPES.UEBERGABE'
    case StopTypes.WECHSEL:
      return 'OPTIMIZATION_RUN_STOPS.STOP_TYPES.WECHSEL'
    case StopTypes.ABHOLUNG:
      return 'OPTIMIZATION_RUN_STOPS.STOP_TYPES.ABHOLUNG'

    default:
      return '-'
  }
}
